import type { TrackRecordItem } from '../types/content';

export const trackRecord: TrackRecordItem[] = [
  {
    number: '01',
    title: 'Responding to Market & Technological Disruption',
    summary:
      'Guided the organization through significant market and technological disruption, repositioning commercial and operational infrastructure ahead of industry-wide change.'
  },
  {
    number: '02',
    title: 'Expanding International Market Reach across EMEA, Americas, and APAC',
    summary:
      'Extended commercial presence across EMEA, the Americas, and APAC, establishing repeatable frameworks for new territory entry.'
  },
  {
    number: '03',
    title: 'Reconfiguring Capability via Strategic Outsourcing (~50% Cost Reduction)',
    summary:
      'Redesigned the operating model and vendor ecosystem, building a leaner, more resilient delivery capability.'
  },
  {
    number: '04',
    title: 'Turning Strategic Partnerships into Commercial Leverage',
    summary:
      'Converted high-stakes partnership negotiations into durable commercial advantage across the enterprise.'
  },
  {
    number: '05',
    title: 'Connecting Strategy with Cross-Functional Execution across Commercial, Tech, Legal, and Finance',
    summary:
      'Partnered across Commercial, Technology, Legal, and Finance to translate strategy into board-level execution.'
  }
];
